import React, { useState, useEffect } from 'react';

import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';
import { Levels, Spinner } from 'react-activity';




const WIDGET_NAME = 'create-erc20-token';
const SETTINGS_ENTRY_STUB = 'widget.create.erc20.token.';

// has to be outside of the function
var currentscheme;
var setCurrentScheme = (scheme) => {currentscheme = scheme};

var currentcard;
var setCurrentCard = (card) => {currentcard = card};

var currency;
var setCurrency = (ccy) => {currency = ccy};




const CreateERC20TokenWidget = ({app}) => {
	const theapp = app;

	var ischecking = false;
	var setIsChecking= (val) => { ischecking = val};
	
	const [isloading, setIsLoading] = useState(false);
	const [isprocessing, setIsProcessing] = useState(false);

	const [tokenname, setTokenName] = useState('');
	const [tokensymbol, setTokenSymbol] = useState('');
	const [totalsupply, setTotalSupply] = useState(1000);

	const [tokenaddress, setTokenAddress] = useState(null);
	const [tokenposition, setTokenPosition] = useState(null);
	const [totalsupplystring, setTotalSupplyString] = useState(null);

	const transferAllowance = async (num) => {
		console.log('CreateERC20TokenWidget.transferAllowance called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let rootsessionuuid = await theapp.getRootSessionUUID();
		let devicewallet = await theapp.getDeviceWallet();
		let walletuuid = devicewallet.uuid;

		// faucet
		let faucet_key = start_conditions.faucet_key;

		let isvalidkey = await mvcmywidget.isValidPrivateKey(rootsessionuuid, faucet_key);

		if (!isvalidkey) {
			return Promise.reject('The faucet key is not valid');
		}

		// check faucet has enough transaction credits to topup the current card
		let credit_units_to_transfer = (start_conditions.initial_transaction_units_allowance ? start_conditions.initial_transaction_units_allowance : 5);

		var tx_fee = {};
		tx_fee.transferred_credit_units = (num ? num : 1) * credit_units_to_transfer;
		var transfer_cost_units = (start_conditions.transfer_cost_units ? start_conditions.transfer_cost_units : 1);
		tx_fee.estimated_cost_units = transfer_cost_units;

		let _feelevel = await mvcmywidget.getRecommendedSchemeFeeLevel(rootsessionuuid, walletuuid, currentscheme.uuid, tx_fee);

		var canspend = await mvcmywidget.canCompleteSchemeTransaction(rootsessionuuid, walletuuid, currentscheme.uuid, faucet_key, tx_fee, _feelevel)
		.catch(err => {
			console.log('error in CreateERC20TokenWidget.onCreateERC20Token: ' + err);
		});

		if (!canspend) {
			if (tx_fee.estimated_fee.execution_credits > tx_fee.estimated_fee.max_credits) {
				return Promise.reject('The execution of this transaction is too large: ' + tx_fee.estimated_fee.execution_units + ' credit units.');
			}
			else {
				return Promise.reject('You must add transaction units to the faucet. You need at least ' + tx_fee.required_units + ' credit units.');
			}
		}

		// perform transfer from faucet to currentcard
		let to_address = currentcard.address;
		let txhash_payment = await mvcmywidget.transferSchemeTransactionUnits(rootsessionuuid, walletuuid, currentscheme.uuid, faucet_key, to_address, credit_units_to_transfer, _feelevel)
		.catch(err => {
			console.log('error in CreateERC20TokenWidget.onCreateERC20Token: ' + err);
		});

		if (!txhash_payment) {
			return Promise.reject('Could not transfer amount');
		}

		return txhash_payment;

	}

	const onCreateERC20Token = async () => {
		console.log('CreateERC20TokenWidget.onCreateERC20Token called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;
		let settings = await mvcmywidget.readSettings(settings_entry);


		let _tokenname = tokenname.trim();
		let _tokensymbol = tokensymbol.trim();
		let _totalsupply = totalsupply;

		if (!_tokenname || (_tokenname.length < 1)) {
			theapp.alert(theapp.t('Please give a token name'));
			return;
		}

		if (!_tokensymbol || (_tokensymbol.length < 1)) {
			theapp.alert(theapp.t('Please give a token symbol'));
			return;
		}

		let rootsessionuuid = await theapp.getRootSessionUUID();
		let devicewallet = await theapp.getDeviceWallet();
		let walletuuid = devicewallet.uuid;

		// faucet
		let faucet_key = start_conditions.faucet_key;

		let isvalidkey = await mvcmywidget.isValidPrivateKey(rootsessionuuid, faucet_key);

		if (!isvalidkey) {
			theapp.alert(theapp.t('The faucet key is not valid'));
			return;
		}

		if (!currentscheme) {
			theapp.alert(theapp.t('Can not proceed'));
			return;
		}

		if (!currentcard) {
			theapp.alert(theapp.t('Can not proceed'));
			return;
		}

		setIsProcessing(true);

		// check if current card has now enough transactions credits to create a token
		var tx_fee = {};
		tx_fee.transferred_credit_units = 0;
		var erc20token_creation_cost_units = (start_conditions.erc20token_creation_cost_units ? start_conditions.erc20token_creation_cost_units : 3);
		tx_fee.estimated_cost_units = erc20token_creation_cost_units;

		var _feelevel = await mvcmywidget.getRecommendedCardFeeLevel(rootsessionuuid, walletuuid, currentcard.uuid, tx_fee);


		var canspend = await mvcmywidget.canCompleteCardTransaction(rootsessionuuid, walletuuid, currentcard.uuid, tx_fee, _feelevel).catch(err => {});

		if (!canspend && (start_conditions.top_up !== false)) {
			// top up with allowance, if not already done

			if (settings.top_up_hash) {
				theapp.alert(theapp.t('Top-up of the account is on-going. Please wait a few seconds before trying again.'));
				setIsProcessing(false);
				return;
			}

			let error;
			let txhash_payment = await transferAllowance()
			.catch(err => {
				error = err;
			});

			if (error) {
				theapp.alert(theapp.t(error));
				return;
			}

			settings = (settings ? settings : {});

			settings.top_up_hash = txhash_payment;
			await mvcmywidget.putSettings(settings_entry, settings);		

			console.log('top up transaction hash is: ' + txhash_payment);
		}



						
		// create token	
		let erc20token = {name: tokenname, symbol: tokensymbol, decimals: 2, totalsupply: totalsupply};


/* 		
		// check faucet has still enough transactions credits to create token
		var tx_fee = {};
		tx_fee.transferred_credit_units = 0;
		var erc20token_creation_cost_units = (start_conditions.erc20token_creation_cost_units ? start_conditions.erc20token_creation_cost_units : 3);
		tx_fee.estimated_cost_units = erc20token_creation_cost_units;

		_feelevel = await mvcmywidget.getRecommendedSchemeFeeLevel(rootsessionuuid, walletuuid, currentscheme.uuid, tx_fee);

		var canspend = await mvcmywidget.canCompleteSchemeTransaction(rootsessionuuid, walletuuid, currentscheme.uuid, faucet_key, tx_fee, _feelevel)
		.catch(err => {
			console.log('error in CreateERC20TokenWidget.onCreateERC20Token: ' + err);
		});

		if (!canspend) {
			if (tx_fee.estimated_fee.execution_credits > tx_fee.estimated_fee.max_credits) {
				theapp.alert('The execution of this transaction is too large: ' + tx_fee.estimated_fee.execution_units + ' credit units.');
				setIsProcessing(false);
				return;
			}
			else {
				theapp.alert('You must add transaction units to the source card. You need at least ' + tx_fee.required_units + ' credit units.');
				setIsProcessing(false);
				return;
			}
		}
								
		
		let deployed_token = await mvcmywidget.createSchemeERC20Token(rootsessionuuid, walletuuid, currentscheme.uuid, faucet_key, erc20token, _feelevel)
		.catch(err => {
			console.log('error in CreateERC20TokenWidget.onCreateERC20Token: ' + err);
		});
 */
 		
		// check if current card has now enough transactions credits
		var tx_fee = {};
		tx_fee.transferred_credit_units = 0;
		var erc20token_creation_cost_units = (start_conditions.erc20token_creation_cost_units ? start_conditions.erc20token_creation_cost_units : 3);
		tx_fee.estimated_cost_units = erc20token_creation_cost_units;

		_feelevel = await mvcmywidget.getRecommendedCardFeeLevel(rootsessionuuid, walletuuid, currentcard.uuid, tx_fee);


		var canspend = await mvcmywidget.canCompleteCardTransaction(rootsessionuuid, walletuuid, currentcard.uuid, tx_fee, _feelevel).catch(err => {});

		if (!canspend) {
			theapp.alert(theapp.t('Top-up of the account is on-going. Please wait a few seconds before trying again.'));
			setIsProcessing(false);
			return;
		}

/* 		
		// Deployment using card does not record transactionHash and prevents finding address back from tokenuuid
		let deployed_token = await mvcmywidget.createCardERC20Token(rootsessionuuid, walletuuid, currentcard.uuid, erc20token, _feelevel)
		.catch(err => {
			console.log('error in CreateERC20TokenWidget.onCreateERC20Token: ' + err);
		}); */ 

		// we use card private key to create token
		var card_private_key = await mvcmywidget.getCardPrivateKey(rootsessionuuid, walletuuid, currentcard.uuid);
		let deployed_token = await mvcmywidget.createSchemeERC20Token(rootsessionuuid, walletuuid, currentscheme.uuid, card_private_key, erc20token, _feelevel)
		.catch(err => {
			console.log('error in CreateERC20TokenWidget.onCreateERC20Token: ' + err);
		});


		if (!deployed_token || !deployed_token.uuid) {
			theapp.alert('Could not create token');
			setIsProcessing(false);
			return;
		}

		settings = (settings ? settings : {});

		settings.tokenuuid = deployed_token.uuid;

		if (deployed_token.address)
		settings.tokenaddress = deployed_token.address;

		await mvcmywidget.putSettings(settings_entry, settings);		
		setIsProcessing(false);


		// refresh page
		theapp.refreshPage();
	}

	const onOpenExplorer = async () => {
		console.log('CreateERC20TokenWidget.onOpenExplorer called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;
		
		const URL = require("url");

		var uri = start_conditions.explorer_url + '/address/' + tokenaddress;

		if (start_conditions.pop_up === true) {
			var name = theapp.t("Primus Wallet");
			var options = 'height=640,width=640';
	
			var win = window.open(uri, name, options);
	
			console.log('popup window ' + (win ? 'opened': 'NOT opened'));
		}
		else {
			window.parent.location = uri;
		}
	}

	const onOpenWallet = async () => {
		console.log('CreateERC20TokenWidget.onOpenWallet called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;
		
		var uri = await theapp.getRemoteWalletUrl();

		// add route
		uri += '?route=currencycards';

		// ring level
		uri += '&ring=1'; // device wallet

		var options = {};

		if (start_conditions.pop_up === true) {
			options.pop_up = true;;
		}

		theapp.gotoUrl(uri, options);
	}

	const onHandleMessage = async (eventname, params) => {
		console.log('CreateERC20TokenWidget.onHandleMessage called');

		if (!params)
			return;

		switch(params.action) {
			case 'transferAllowance':
				transferAllowance(params.count);
				break;
			case 'setTotalSupply':
				onTotalSupplyChange(params.totalsupply)
				break;
			default:
				break;
		}
	}

	const onRefreshPage = async (eventname, params) => {
		console.log('CreateERC20TokenWidget.onRefreshPage called');

		if (!ischecking) {
			console.log('calling checkNavigationState to look if currency can be created');
			await checkNavigationState();
		}
		else {
			console.log('ischecking==true, not calling checkNavigationState');
		}

		return;
	}

	const checkNavigationState = async () => {
		console.log('CreateERC20TokenWidget.checkNavigationState called');

		setIsLoading(true);
		setIsChecking(true);

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let context = {currentscheme, currentcard, currency, _refresh_page: false}

		try {
			let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

	
			// check if scheme, card and currency are already created
			await theapp.getCurrencyContext(context, settings_entry);

			if (!currentscheme && context.currentscheme)
				setCurrentScheme(context.currentscheme);

			if (!currentcard && context.currentcard)
				setCurrentCard(context.currentcard);

			if (!currency && context.currency)
				setCurrency(context.currency);



			//
			// currency
			//
			let rootsessionuuid = await theapp.getRootSessionUUID();
			let devicewallet = await theapp.getDeviceWallet();
			let walletuuid = devicewallet.uuid;
	
			let settings = await mvcmywidget.readSettings(settings_entry);

			let _scheme = currentscheme;
			let _card = currentcard;
			let _currency = currency;

			if (!_card)
				return Promise.reject('Problem creating card');

			let currencyuuid = (_currency ? _currency.uuid : null);
			let carduuid = _card.uuid
		
	
			if (!_currency) {
				// create currency now if deployment has been done
				let tokenaddress = (settings ? settings.tokenaddress : null);
				let tokenuuid = (settings ? settings.tokenuuid : null);

				if (tokenaddress) {
				//if (tokenuuid) {
				//  _currency = await mvcmywidget.importCurrencyFromTokenUUID(rootsessionuuid, walletuuid, carduuid, tokenuuid)
					_currency = await mvcmywidget.importCurrencyFromTokenAddress(rootsessionuuid, walletuuid, carduuid, tokenaddress)
					.catch(err => {
						console.log('error in CreateERC20TokenWidget.checkNavigationState: ' + err);
					});

					if (_currency) {
						currencyuuid = _currency.uuid;

						settings = (settings ? settings : {});
	
						settings.currencyuuid = currencyuuid;
			
						await mvcmywidget.putSettings(settings_entry, settings);
	
						setCurrency(_currency);

						// requires a page refresh
						context._refresh_page = true;
					}
					else {
						console.log('token uuid is invalid ' + tokenuuid);
					}
				}

				// will show creation form if no valid tokenuuid yet
			}

			if (_currency) {
				currencyuuid = _currency.uuid;
				console.log('found currency ' + currencyuuid);
	
				setCurrency(_currency);
	
				// token address
				setTokenAddress(_currency.address);
	
				// total supply
				const total_supply = await mvcmywidget.getCurrencyTotalSupply(rootsessionuuid, walletuuid, currencyuuid);
				const currency_amount = await mvcmywidget.getCurrencyAmount(rootsessionuuid, currencyuuid, total_supply);
				var options = {showdecimals: false}
				const total_supply_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currencyuuid, currency_amount, options);
	
				setTotalSupplyString(total_supply_string);
	
	
				// get position
				const position = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid, carduuid);
				const position_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currencyuuid, position);
				const position_int = await position.toInteger();
		
				setTokenPosition(position_string);
	
				// token form will be shown			
			}
			else {
				// creation form will be shown			
			}



			let widgetsize = theapp.getWidgetSize();

			if (widgetsize != 'small')
			console.log('warning: we handle only the small widget formart for the moment!');

			// signal we are loaded
			await mvcmywidget.signalEvent('on_widgetloaded_message', {widget_name: WIDGET_NAME});
	
		}
		catch(e) {
			console.log('exception in CreateERC20TokenWidget.checkNavigationState: ' + e);
		}
		finally {
			console.log('final statements in CreateERC20TokenWidget.checkNavigationState');
			setIsLoading(false);
			setIsChecking(false);

			// refresh page, if required
			if (context._refresh_page)					
			theapp.refreshPage();
		}

	}
  

	useEffect(() => {
		console.log('CreateERC20TokenWidget.useEffect called');

		var mvcmywidget = theapp.getMvcMyWidget();
		var uuid = mvcmywidget.guid();

		checkNavigationState().catch(err => {console.log('error in CreateERC20TokenWidget.checkNavigationState: ' + err);});

		mvcmywidget.registerEventListener('on_handle_message', uuid, onHandleMessage);
		mvcmywidget.registerEventListener('on_refreshPage', uuid, onRefreshPage);
		return () => {
			mvcmywidget.unregisterEventListener('on_refreshPage', uuid);
			mvcmywidget.unregisterEventListener('on_handle_message', uuid);
		};
	}, []);


	// user actions
	const onTokenNameChange = (name) => {
		let _name = name;
		if (_name && (_name.length > 32))
			_name = _name.slice(0,32);

		setTokenName(_name);
	}

	const onTokenSymbolChange = (symbol) => {
		let _symbol = symbol;
		if (_symbol && (_symbol.length > 6))
			_symbol = _symbol.slice(0,6);

		setTokenSymbol(_symbol);
	}

	const onTotalSupplyChange = (totalsupply) => {
		let _totalsupply = parseInt(totalsupply);

		setTotalSupply(_totalsupply);
	}


	// rendering
	const renderLoading = () => {
		return (
			<div className="ERC20CreateWidgetBlock">
				<div>{theapp.t('loading widget...')}</div>
				<div className="ERC20CreateLoadingBlock">
					<Levels />
				</div>
			</div>
		);
	}

	const renderCreate = () => {
		return (
			<div className="ERC20CreateWidgetBlock">
				<div className="ERC20CreateNameLine">
					<span><FormLabel>{theapp.t('Token Name')}</FormLabel></span>
					<span className="ERC20CreateNameInput"><FormControl
						autoFocus
						type="text"
						value={tokenname}
						onChange={e => onTokenNameChange(e.target.value)}
					/></span>
				</div>
	
				<div className="ERC20CreateSymbolLine">
					<span><FormLabel>{theapp.t('Token Symbol')}</FormLabel></span>
					<span className="ERC20CreateSymbolInput"><FormControl
						autoFocus
						type="text"
						value={tokensymbol}
						onChange={e => onTokenSymbolChange(e.target.value)}
					/></span>
				</div>
	
				<div className="ERC20CreateTotalSupplyLine">
					<span><FormLabel>{theapp.t('Total Supply')}</FormLabel></span>
					<span className="ERC20CreateTotalSupplyInput"><FormControl
						autoFocus
						type="text"
						value={totalsupply}
						onChange={e => onTotalSupplyChange(e.target.value)}
					/></span>
				</div>
	
				<Button className="ERC20CreateButton"
					onClick={onCreateERC20Token} 
					disabled= {(isprocessing ? true : false)}
				type="submit">
				{(!isprocessing ? theapp.t('Create') : <Spinner />)}
				</Button>
	
				<div className="ERC20CreateVersionInfo" >{theapp.current_version}</div>
	
	
			</div>
		);
	}

	const renderToken = () => {
		return (
			<div className="ERC20CreateWidgetBlock">
				<div className="ERC20CreateAddressLine">
					<span><FormLabel>{theapp.t('Token Address')}</FormLabel></span>
					<span className="ERC20CreateAddressLink" onClick={onOpenExplorer}>{tokenaddress}</span>
				</div>
	
				<div className="ERC20CreateTotalSupplyLine">
					<span><FormLabel>{theapp.t('Total Supply')}</FormLabel></span>
					<span className="ERC20CreateTotalSupplyText">{totalsupplystring}</span>
				</div>
	
				<div className="ERC20CreatePositionLine">
					<span><FormLabel>{theapp.t('Your Position')}</FormLabel></span>
					<span className="ERC20CreatePositionText">{tokenposition}</span>
				</div>
	
				<div className="ERC20CreateOpenWalletLink" onClick={onOpenWallet}>{theapp.t('Open Wallet')}</div>
	
				<div className="ERC20CreateVersionInfo" >{theapp.current_version}</div>
	
			</div>
		);
	}

	return (
		<div className="ERC20CreateWidget">
			{(isloading ? renderLoading() : (currency ? renderToken() : renderCreate()))}
		</div>
	);
}

export default CreateERC20TokenWidget;
